module.exports = __webpack_public_path__ + "static/second_user_image5-6c5acf38c653ca39c5ee1e992cfa03b9.jpg";